<template>
    <InventoryHistory></InventoryHistory>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const InventoryHistory = defineAsyncComponent(() =>
    import("../../components/SAW/InventoryHistory.vue")
);

export default {
    name: "SAW_InventoryHistory", //The name you are in should not equal the name of the component you are importing.
    components: { InventoryHistory, AuthLayout },
};
</script>
